import { useCareplan } from "@/domains/careplan/queries/use-careplan";
import { selectIsProgressEnabled } from "@/domains/progress/utils/progress-entry-points";

export const useIsProgressEnabled = () => {
  const { careplan } = useCareplan();

  return selectIsProgressEnabled(careplan);
};
